<template>
  <div class="loader">
    <div class="product-filter-title">
      <GFMP :styles="{ ...fmpStyles.rounded, height: '16px', width: getRandomPercentage(40, 55) }" />
    </div>
    <div class="product-filter-category">
      <GFMP :styles="{ ...fmpStyles.rounded, height: '16px', width: getRandomPercentage(40, 55) }" />
      <GFMP v-for="i in 5" :key="i" :styles="{ ...fmpStyles.rounded, width: getRandomPercentage(40) }" />
    </div>
    <div class="product-filter-availability">
      <GFMP :styles="{ ...fmpStyles.rounded, height: '16px', width: getRandomPercentage(40, 55) }" />
      <div v-for="i in 2" :key="i" class="availability-item">
        <GFMP :styles="fmpStyles.circle" />
        <GFMP :styles="{ ...fmpStyles.rounded, width: getRandomPercentage(40) }" />
      </div>
    </div>
    <div class="product-filter-brand">
      <GFMP :styles="{ ...fmpStyles.rounded, height: '16px', width: getRandomPercentage(40, 55) }" />
      <div class="brand-tab">
        <GFMP v-for="i in 2" :key="i" :styles="{ ...fmpStyles.rounded, width: getRandomPercentage(70, 90) }" />
      </div>
      <div class="brand-search">
        <GFMP :styles="{ ...fmpStyles.rounded, width: getRandomPercentage(80, 90) }" />
        <GFMP :styles="fmpStyles.circle" />
      </div>
      <div v-for="i in 5" :key="i" class="brand-item">
        <GFMP :styles="fmpStyles.circle" />
        <GFMP :styles="{ ...fmpStyles.rounded, width: getRandomPercentage(40) }" />
      </div>
    </div>
    <div class="product-filter-rating">
      <GFMP :styles="{ ...fmpStyles.rounded, height: '16px', width: getRandomPercentage(40, 55) }" />
      <div v-for="i in 5" :key="i" class="rating-item">
        <GFMP :styles="fmpStyles.circle" />
        <div class="rating-item-label">
          <GFMP v-for="_i in 5" :key="_i" :styles="{ ...fmpStyles.circle, height: '16px', minWidth: '16px' }" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'product-filter-loader',
  data() {
    return {
      fmpStyles: {
        rounded: {
          borderRadius: '8px',
          height: '12px',
        },
        circle: {
          borderRadius: '50%',
          height: '20px',
        },
      },
    };
  },
  methods: {
    getRandomPercentage(min = 40, max = 100) {
      return `${min + Math.random() * (max - min)}%`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/sass/_mixin-revamp.scss';

$defaultGap: 16px;

@mixin flexColumn {
  display: flex;
  flex-direction: column;
}

@mixin flexSpaceBetween {
  display: flex;
  justify-content: space-between;
}

@mixin defaultBox {
  width: 100%;
  padding: 16px;
  border-bottom: 1px solid #e5e5e5;
}

@mixin defaultBoxFlexColumn {
  @include defaultBox();
  @include flexColumn();
  gap: $defaultGap;
}

@mixin checkBox($isRating: false) {
  display: flex;
  gap: 8px;
  align-items: center;

  @if ($isRating == false) {
    :last-child {
      flex-grow: 1;
    }
  }
}

.loader {
  all: inherit;

  :last-child {
    border-bottom: none !important;
  }
  .product-filter {
    &-title {
      @include defaultBox();
    }

    &-category {
      @include defaultBoxFlexColumn();
    }

    &-availability {
      @include defaultBoxFlexColumn();

      .availability {
        &-item {
          @include checkBox();
        }
      }
    }

    &-brand {
      @include defaultBoxFlexColumn();

      .brand {
        &-tab {
          @include defaultBox();
          display: flex;
          padding: 8px;

          & * {
            flex-grow: 1;
          }
        }

        &-search {
          display: flex;
          align-items: center;

          :first-child {
            flex-grow: 1;
          }
        }

        &-item {
          @include checkBox();
        }
      }
    }

    &-rating {
      @include defaultBoxFlexColumn();

      .rating {
        &-item {
          @include checkBox(true);

          &-label {
            display: flex;
            gap: 4px;
          }
        }
      }
    }
  }
}
</style>
